/**
 * @desc 内容区域加载状态组件
 * @time 2023-07-31 15:32:43
 * @user simxin
 */

import ReactDOM from 'react-dom';
import { ConfigProvider, Status, StatusTip } from '@tencent/tea-component';
import { t } from '@src/utils/translate';
import { usePortalStore } from '@src/store';
import { getPrimaryLink } from '@src/utils/tools/other-site-tools';

/**
 * @desc 常规`加载中`组件
 */
export const LoadingStatus = () => (
  <div className="micro-loading-portal">
    <StatusTip status="loading" loadingText={t('Loading...')} />
  </div>
);

/**
 * @desc 页面初始化进入时的前置加载组件
 */
export const loadPortal = () => {
  const root = document.getElementById('root');
  ReactDOM.render(
    <ConfigProvider classPrefix={'trtc-tea'}>
      <LoadingStatus />
    </ConfigProvider>,
    root,
  );
};

/**
 * @desc 错误提示页
 */
export const ErrorStatus = () => {
  const errorCode = usePortalStore(state => state.errorCode);

  /**
   * @desc 兼容老用户
   */
  if (errorCode === 'InternalError.GetAppIdError') {
    return (
      <div className="micro-error-portal">
        <Status
          icon={'no-permission'}
          title={t('Incomplete account information')}
          description={t(
            'After completing the account information, you can use the TRTC services.',
          )}
          operation={
            <>
              <a
                style={{ color: '#999' }}
                href={`//${window.AVPORTAL_HOST}/login`}
              >
                {t('<< Log in with another account')}
              </a>
              <a
                style={{ marginLeft: '30px' }}
                href={`${getPrimaryLink('/account/login')}`}
              >
                {t('Improve Now')}
              </a>
            </>
          }
        />
      </div>
    );
  }

  return (
    <div className="micro-error-portal">
      <Status icon={'network'} title="" description="Page Error" />
    </div>
  );
};
